var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTireFinderWarranty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "s2lq15xdna"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e6ugymdqyb"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#s2lq15xdna)",
    transform: "translate(-24 -588) translate(24 588.406)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.6,
    d: "M9.736.881l8.937 4.131v7.79c0 1.98-.976 3.704-2.241 5.136-2.272 2.571-5.508 4.23-6.465 4.688-1.005-.332-4.333-1.95-6.706-4.474C1.876 16.679.8 14.882.8 12.802h0v-7.79L9.736.882z",
    transform: "translate(4.314 2.231)"
  }))), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    filter: "url(#e6ugymdqyb)",
    transform: "translate(-24 -588) translate(24 588.406)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.5,
    d: "M1.085 5.826L4.171 8.332 8.308 1.08",
    transform: "translate(9.5 9.231) rotate(4 4.697 4.706)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTireFinderWarranty);
export default __webpack_public_path__ + "static/media/icon-tire-finder-warranty.7a93e7d1fe98ddceb47c1a36bb319957.svg";
export { ForwardRef as ReactComponent };